module.exports = __webpack_public_path__ + "static/media/done4.3a755ecf.gif";